/**
 * Helper for styled file upload inputs
 * Mirrors the file name of a chosen file to the .filename-container
 */
import $ from 'jquery';

import App from 'libs/app';

const regex = /[^\\]+$/;
App.registerUiComponent('filename-display', () => {
    $("input[type='file']").filter(function () {
        // only inputs that have a custom filename element as sibling
        return $(this).siblings('.filename').length > 0;
    })
        .off('change.filename-display')
        .on('change.filename-display', function () {
            $(this).siblings('.filename').text(this.value.match(regex));
        });
});
